const DAYS_PER_MONTH = 30;
const MIN_DAYS_TO_SHOW_MONTHS = 360;
const SINGLE = 1;

const pluralize = (amount, singular, plural) => `${amount} ${amount === SINGLE ? singular : plural}`;

export const formatPackageValidity = (validDays, months) => {
    if (months) return pluralize(months, 'mês', 'meses');

    const days = Number(validDays);
    if (!days) return null;

    if (days >= MIN_DAYS_TO_SHOW_MONTHS) return pluralize(Math.round(days / DAYS_PER_MONTH), 'mês', 'meses');

    return pluralize(days, 'dia', 'dias');
};

const isPositiveInteger = (value) => Number.isInteger(value) && value > 0;

export const promotionValidDays = (voucher) => {
    const validDays = voucher?.packageBenefits?.validDays;
    return isPositiveInteger(validDays) ? validDays : null;
};

export const withPromotionValidity = (product, voucher) => {
    const validDays = promotionValidDays(voucher);
    return product && validDays ? { ...product, validDays, months: null } : product;
};
